/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { Token1, Token1Interface } from "../Token1";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "_nativeTokenSymbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "_ftsoManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "_visToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_wNat",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_ORDER",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_SUPPLY",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NFTRewardManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PACK_SUPPLY",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VALIDREWARDEPOCH",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_mintableRankThres",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "_epochId",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "_orderCount",
        type: "uint8",
      },
    ],
    name: "_addOrderByRM",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_epochId",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "_orderCount",
        type: "uint8",
      },
    ],
    name: "_removeOrderByRM",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "_totalSupplied",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimByOrderer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "_id",
        type: "uint32",
      },
    ],
    name: "claimByRewardManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_epochId",
        type: "uint32",
      },
    ],
    name: "claimOneByOrderer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "createOrderForFree",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_orderCount",
        type: "uint8",
      },
    ],
    name: "createOrderWithFLR",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "_orderCount",
        type: "uint8",
      },
    ],
    name: "createOrderWithPayableTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_orderCount",
        type: "uint8",
      },
    ],
    name: "createSafeOrder",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "deadAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "flipPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "ftsoManager",
    outputs: [
      {
        internalType: "contract IFtsoManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ftsoRegistry",
    outputs: [
      {
        internalType: "contract IIFtsoRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "ftsoes",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getClaimableEpochEndId",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_rank",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_mintableRankThres",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_vpBlock",
        type: "uint256",
      },
    ],
    name: "getClaimableId",
    outputs: [
      {
        internalType: "uint32",
        name: "id",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orderer",
        type: "address",
      },
    ],
    name: "getClaimableOrderCount",
    outputs: [
      {
        internalType: "uint32",
        name: "count",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
    ],
    name: "getCurrentTokenPriceBySymbol",
    outputs: [
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_assetPriceUsdDecimals",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orderer",
        type: "address",
      },
    ],
    name: "getDeliveringOrderCount",
    outputs: [
      {
        internalType: "uint32",
        name: "count",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "getOrderable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "orderer",
        type: "address",
      },
    ],
    name: "getOrders",
    outputs: [
      {
        internalType: "uint32[]",
        name: "",
        type: "uint32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalOrdered",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_nftId",
        type: "uint32",
      },
    ],
    name: "getVISAmountOfId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "goingPercentageToVault",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    name: "ids",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintFLRCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintUSDCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nativeTokenSymbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orderedByOrderer",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    name: "orderedByRM",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "orders",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "payableTokenSymbolOf",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newMintFLRCost",
        type: "uint256",
      },
    ],
    name: "setMintFLRCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newMintUSDCost",
        type: "uint256",
      },
    ],
    name: "setMintUSDCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    name: "setPayableToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_goingPercentageToVault",
        type: "uint256",
      },
    ],
    name: "setPercentageToVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_turnon",
        type: "bool",
      },
    ],
    name: "setTurnOnWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_whitelist",
        type: "address[]",
      },
    ],
    name: "setWhitelistedAcc",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_willUseFLRCost",
        type: "bool",
      },
    ],
    name: "setWillUseFLRCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftRewardManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "_ftsoManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vaultAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_votingAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_visToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_WNat",
        type: "address",
      },
      {
        internalType: "string",
        name: "_newBaseURI",
        type: "string",
      },
    ],
    name: "setting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "tokenClaimedStatus",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "turnOnWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vaultAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "visToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "votingAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "wNat",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
    ],
    name: "walletOfOwner",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelisted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "willUseFLRCost",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "address",
        name: "_erc20token",
        type: "address",
      },
    ],
    name: "withdrawERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_to",
        type: "address",
      },
    ],
    name: "withdrawFLR",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60e0604052603c60808181529062005e3860a03980516200002991600b916020909101906200027a565b503480156200003757600080fd5b5060405162005e7438038062005e748339810160408190526200005a916200046f565b855186908690620000739060009060208501906200027a565b508051620000899060019060208401906200027a565b5050600a805460ff1916905550620000a13362000220565b8351620000b690600c9060208701906200027a565b50601c80546001600160a01b0319166001600160a01b0385169081179091556040805163ce69f83360e01b8152905163ce69f83391600480820192600092909190829003018186803b1580156200010c57600080fd5b505afa15801562000121573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526200014b919081019062000541565b8051620001619160129160209091019062000309565b50826001600160a01b03166338b5f8696040518163ffffffff1660e01b815260040160206040518083038186803b1580156200019c57600080fd5b505afa158015620001b1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620001d79190620005ff565b601d80546001600160a01b03199081166001600160a01b039384161790915560158054821693831693909317909255601e80549092169216919091179055506200066392505050565b600a80546001600160a01b03838116610100818102610100600160a81b031985161790945560405193909204169182907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b828054620002889062000626565b90600052602060002090601f016020900481019282620002ac5760008555620002f7565b82601f10620002c757805160ff1916838001178555620002f7565b82800160010185558215620002f7579182015b82811115620002f7578251825591602001919060010190620002da565b506200030592915062000361565b5090565b828054828255906000526020600020908101928215620002f7579160200282015b82811115620002f757825182546001600160a01b0319166001600160a01b039091161782556020909201916001909101906200032a565b5b8082111562000305576000815560010162000362565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f191681016001600160401b0381118282101715620003b957620003b962000378565b604052919050565b600082601f830112620003d357600080fd5b81516001600160401b03811115620003ef57620003ef62000378565b602062000405601f8301601f191682016200038e565b82815285828487010111156200041a57600080fd5b60005b838110156200043a5785810183015182820184015282016200041d565b838111156200044c5760008385840101525b5095945050505050565b6001600160a01b03811681146200046c57600080fd5b50565b60008060008060008060c087890312156200048957600080fd5b86516001600160401b0380821115620004a157600080fd5b620004af8a838b01620003c1565b97506020890151915080821115620004c657600080fd5b620004d48a838b01620003c1565b96506040890151915080821115620004eb57600080fd5b50620004fa89828a01620003c1565b94505060608701516200050d8162000456565b6080880151909350620005208162000456565b60a0880151909250620005338162000456565b809150509295509295509295565b600060208083850312156200055557600080fd5b82516001600160401b03808211156200056d57600080fd5b818501915085601f8301126200058257600080fd5b81518181111562000597576200059762000378565b8060051b9150620005aa8483016200038e565b8181529183018401918481019088841115620005c557600080fd5b938501935b83851015620005f35784519250620005e28362000456565b8282529385019390850190620005ca565b98975050505050505050565b6000602082840312156200061257600080fd5b81516200061f8162000456565b9392505050565b600181811c908216806200063b57607f821691505b602082108114156200065d57634e487b7160e01b600052602260045260246000fd5b50919050565b6157c580620006736000396000f3fe60806040526004361061045d5760003560e01c80636c0360eb1161023f578063afd9364311610139578063e7bd45ea116100b6578063f55390f51161007a578063f55390f514610d9f578063f8748e4014610dc5578063fb382f7b14610de5578063fd76fe1814610e05578063ffcff4f714610e2557600080fd5b8063e7bd45ea14610ceb578063e985e9c514610d01578063ed8e0bc714610d4a578063ee41be1514610d5f578063f2fde38b14610d7f57600080fd5b8063c4904ed7116100fd578063c4904ed714610c48578063c82715ae14610c68578063c87b56dd14610c7e578063d2fa717014610c9e578063d936547e14610cbe57600080fd5b8063afd9364314610b95578063b52a3e0414610bb5578063b88d4fde14610be8578063b8edc48814610c08578063c010f2b014610c2857600080fd5b80638da5cb5b116101c7578063a22cb4651161018b578063a22cb46514610ad9578063a68698f814610af9578063a8f4b4ba14610b18578063ac9e2f6514610b48578063aea2c5c314610b6857600080fd5b80638da5cb5b14610a4c5780639456fbcc14610a6f57806395d89b4114610a8f57806398e673d114610aa45780639edbf00714610ab957600080fd5b80637f0749c81161020e5780637f0749c8146109975780637fb8891f146109cc57806384c1fa07146109ec5780638689715214610a0c5780638d753d7c14610a2c57600080fd5b80636c0360eb1461092d57806370a0823114610942578063715018a614610962578063793b8c6d1461097757600080fd5b80633270dd3d1161035b57806347061fc0116102d8578063566271db1161029c578063566271db146108b0578063573809c1146108cd5780635c975abb146108e25780635e38f4ae146108fa5780636352211e1461090d57600080fd5b806347061fc01461081b5780634acfc23a1461083b5780634f6ccce71461085b57806350c5a00c1461087b578063517d9fef1461089057600080fd5b80633e0d17c71161031f5780633e0d17c71461076e57806342842e0e1461078e578063430bf08a146107ae578063438b6300146107ce578063446b21e9146107fb57600080fd5b80633270dd3d146106f057806332cb6b0c14610710578063333171bb1461072657806338b5f8691461073b5780633d536a011461075b57600080fd5b8063123219c5116103e957806323b872dd116103ad57806323b872dd1461066a57806323d4a6881461068a57806326b1cfe5146106a457806327c8f835146106ba5780632f745c59146106d057600080fd5b8063123219c5146105e057806318160ddd146106005780631abbc53a1461061f5780631b54e79c146106355780631dd841431461064a57600080fd5b8063081812fc11610430578063081812fc14610519578063093376fe14610551578063095ea7b31461057e5780630b88f1de146105a057806311a7aaaa146105c057600080fd5b806301ffc9a714610462578063056de0fe1461049757806306fdde03146104be5780630748fcbb146104e0575b600080fd5b34801561046e57600080fd5b5061048261047d36600461494c565b610e3a565b60405190151581526020015b60405180910390f35b3480156104a357600080fd5b506104ac600a81565b60405160ff909116815260200161048e565b3480156104ca57600080fd5b506104d3610e65565b60405161048e91906149c1565b3480156104ec57600080fd5b50600d5461050490600160201b900463ffffffff1681565b60405163ffffffff909116815260200161048e565b34801561052557600080fd5b506105396105343660046149d4565b610ef7565b6040516001600160a01b03909116815260200161048e565b34801561055d57600080fd5b5061057161056c366004614a02565b610f1e565b60405161048e9190614a1f565b34801561058a57600080fd5b5061059e610599366004614a69565b610fb6565b005b3480156105ac57600080fd5b5061059e6105bb3660046149d4565b6110d1565b3480156105cc57600080fd5b50601c54610539906001600160a01b031681565b3480156105ec57600080fd5b506104826105fb366004614abf565b6110de565b34801561060c57600080fd5b506008545b60405190815260200161048e565b34801561062b57600080fd5b50610611600e5481565b34801561064157600080fd5b506104d3611190565b34801561065657600080fd5b5061059e6106653660046149d4565b61121e565b34801561067657600080fd5b5061059e610685366004614af2565b61122b565b34801561069657600080fd5b506011546104829060ff1681565b3480156106b057600080fd5b50610611600f5481565b3480156106c657600080fd5b5061053961dead81565b3480156106dc57600080fd5b506106116106eb366004614a69565b611347565b3480156106fc57600080fd5b5061050461070b366004614a02565b6113dd565b34801561071c57600080fd5b50610504612b6781565b34801561073257600080fd5b5061059e61149d565b34801561074757600080fd5b50601d54610539906001600160a01b031681565b61059e610769366004614b33565b6114c1565b34801561077a57600080fd5b5061059e610789366004614a02565b61167f565b34801561079a57600080fd5b5061059e6107a9366004614af2565b6116c0565b3480156107ba57600080fd5b50601354610539906001600160a01b031681565b3480156107da57600080fd5b506107ee6107e9366004614a02565b6116db565b60405161048e9190614b4e565b34801561080757600080fd5b50610611610816366004614b86565b611783565b34801561082757600080fd5b5061059e610836366004614b86565b61189e565b34801561084757600080fd5b50610504610856366004614ba1565b611aae565b34801561086757600080fd5b506106116108763660046149d4565b611ce2565b34801561088757600080fd5b506104ac601481565b34801561089c57600080fd5b506106116108ab366004614a02565b611d75565b3480156108bc57600080fd5b50600d546105049063ffffffff1681565b3480156108d957600080fd5b50610504611d99565b3480156108ee57600080fd5b50600a5460ff16610482565b61059e610908366004614b33565b611e9a565b34801561091957600080fd5b506105396109283660046149d4565b6120a6565b34801561093957600080fd5b506104d3612106565b34801561094e57600080fd5b5061061161095d366004614a02565b612113565b34801561096e57600080fd5b5061059e612199565b34801561098357600080fd5b50610504610992366004614a69565b6121ab565b3480156109a357600080fd5b506109b76109b2366004614c8c565b6121f4565b6040805192835260208301919091520161048e565b3480156109d857600080fd5b5061059e6109e7366004614ccf565b612285565b3480156109f857600080fd5b5061059e610a073660046149d4565b6122a0565b348015610a1857600080fd5b50610504610a27366004614a02565b6122ad565b348015610a3857600080fd5b506104d3610a47366004614a02565b612365565b348015610a5857600080fd5b50600a5461010090046001600160a01b0316610539565b348015610a7b57600080fd5b5061059e610a8a366004614cec565b61237e565b348015610a9b57600080fd5b506104d3612485565b348015610ab057600080fd5b5061059e612494565b348015610ac557600080fd5b50601554610539906001600160a01b031681565b348015610ae557600080fd5b5061059e610af4366004614d25565b6125ea565b348015610b0557600080fd5b5060115461048290610100900460ff1681565b348015610b2457600080fd5b50610482610b33366004614b86565b60176020526000908152604090205460ff1681565b348015610b5457600080fd5b5061059e610b63366004614d53565b6125f5565b348015610b7457600080fd5b50610611610b83366004614a02565b60196020526000908152604090205481565b348015610ba157600080fd5b50601e54610539906001600160a01b031681565b348015610bc157600080fd5b50610504610bd0366004614b86565b601b6020526000908152604090205463ffffffff1681565b348015610bf457600080fd5b5061059e610c03366004614e00565b61273d565b348015610c1457600080fd5b5061059e610c23366004614e80565b61276f565b348015610c3457600080fd5b50610482610c43366004614eac565b6129c7565b348015610c5457600080fd5b5061059e610c63366004614eef565b612aea565b348015610c7457600080fd5b5061061160105481565b348015610c8a57600080fd5b506104d3610c993660046149d4565b612f09565b348015610caa57600080fd5b50601454610539906001600160a01b031681565b348015610cca57600080fd5b50610611610cd9366004614a02565b60166020526000908152604090205481565b348015610cf757600080fd5b5061050461010f81565b348015610d0d57600080fd5b50610482610d1c366004614cec565b6001600160a01b03918216600090815260056020908152604080832093909416825291909152205460ff1690565b348015610d5657600080fd5b50610504612f7d565b348015610d6b57600080fd5b50610539610d7a3660046149d4565b61305f565b348015610d8b57600080fd5b5061059e610d9a366004614a02565b613089565b348015610dab57600080fd5b50601154610539906201000090046001600160a01b031681565b348015610dd157600080fd5b5061059e610de0366004614f0d565b613102565b348015610df157600080fd5b5061059e610e00366004614fb6565b61312d565b348015610e1157600080fd5b5061059e610e20366004614ccf565b6131f9565b348015610e3157600080fd5b5061059e61321b565b60006001600160e01b0319821663780e9d6360e01b1480610e5f5750610e5f82613369565b92915050565b606060008054610e749061504a565b80601f0160208091040260200160405190810160405280929190818152602001828054610ea09061504a565b8015610eed5780601f10610ec257610100808354040283529160200191610eed565b820191906000526020600020905b815481529060010190602001808311610ed057829003601f168201915b5050505050905090565b6000610f02826133b9565b506000908152600460205260409020546001600160a01b031690565b6001600160a01b038116600090815260186020908152604091829020805483518184028101840190945280845260609392830182828015610faa57602002820191906000526020600020906000905b82829054906101000a900463ffffffff1663ffffffff1681526020019060040190602082600301049283019260010382029150808411610f6d5790505b50505050509050919050565b6000610fc1826120a6565b9050806001600160a01b0316836001600160a01b031614156110345760405162461bcd60e51b815260206004820152602160248201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e656044820152603960f91b60648201526084015b60405180910390fd5b336001600160a01b038216148061105057506110508133610d1c565b6110c25760405162461bcd60e51b815260206004820152603d60248201527f4552433732313a20617070726f76652063616c6c6572206973206e6f7420746f60448201527f6b656e206f776e6572206f7220617070726f76656420666f7220616c6c000000606482015260840161102b565b6110cc8383613418565b505050565b6110d9613486565b600f55565b6011546000906201000090046001600160a01b031633146111115760405162461bcd60e51b815260040161102b90615085565b63ffffffff8084166000908152601b602052604090205460ff84169116101561113c57506000610e5f565b63ffffffff8084166000908152601b60205260408120805460ff861693919291611168918591166150ca565b92506101000a81548163ffffffff021916908363ffffffff1602179055506001905092915050565b600c805461119d9061504a565b80601f01602080910402602001604051908101604052809291908181526020018280546111c99061504a565b80156112165780601f106111eb57610100808354040283529160200191611216565b820191906000526020600020905b8154815290600101906020018083116111f957829003601f168201915b505050505081565b611226613486565b601055565b6013546001600160a01b031663d461bf38848461124782612113565b6040516001600160e01b031960e086901b1681526001600160a01b039384166004820152929091166024830152604482015260648101849052608401600060405180830381600087803b15801561129d57600080fd5b505af11580156112b1573d6000803e3d6000fd5b50506014546040516334e16f8760e11b81526001600160a01b0387811660048301526001602483015290911692506369c2df0e9150604401602060405180830381600087803b15801561130357600080fd5b505af1158015611317573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061133b91906150ef565b506110cc8383836134e6565b600061135283612113565b82106113b45760405162461bcd60e51b815260206004820152602b60248201527f455243373231456e756d657261626c653a206f776e657220696e646578206f7560448201526a74206f6620626f756e647360a81b606482015260840161102b565b506001600160a01b03919091166000908152600660209081526040808320938352929052205490565b6000806113e8612f7d565b905060005b6001600160a01b03841660009081526018602052604090205463ffffffff82161015611496576001600160a01b0384166000908152601860205260409020805463ffffffff80851692919084169081106114495761144961510c565b6000918252602090912060088204015460079091166004026101000a900463ffffffff16111561147857611484565b61148183615122565b92505b8061148e81615122565b9150506113ed565b5050919050565b6114a5613486565b600a5460ff166114b9576114b7613517565b565b6114b7613571565b6114c96135aa565b600d548190612b679060ff831690600160201b900463ffffffff166114ec611d99565b6114f69190615146565b6115009190615146565b63ffffffff1611156115245760405162461bcd60e51b815260040161102b9061516e565b33828060ff1661153383611d75565b10156115515760405162461bcd60e51b815260040161102b9061519c565b60115460ff1615156001146115a85760405162461bcd60e51b815260206004820152601a60248201527f77696c6c557365464c52436f7374206973206e6f742074727565000000000000604482015260640161102b565b8360ff16600f546115b991906151d3565b3410156115fd5760405162461bcd60e51b8152602060048201526012602482015271496e73756666696369656e742076616c756560701b604482015260640161102b565b6013546010546001600160a01b039091169063f6326fb39060649061162290346151d3565b61162c9190615208565b6040518263ffffffff1660e01b81526004016000604051808303818588803b15801561165757600080fd5b505af115801561166b573d6000803e3d6000fd5b5050505050611679846135f0565b50505050565b611687613486565b6040516001600160a01b038216904780156108fc02916000818181858888f193505050501580156116bc573d6000803e3d6000fd5b5050565b6110cc8383836040518060200160405280600081525061273d565b606060006116e883612113565b905060008167ffffffffffffffff81111561170557611705614bcd565b60405190808252806020026020018201604052801561172e578160200160208202803683370190505b50905060005b8281101561177b5760006117488683611347565b90508083838151811061175d5761175d61510c565b602090810291909101015250806117738161521c565b915050611734565b509392505050565b601e546001600160a01b03166000818152601960205260408082205490516370a0823160e01b8152306004820152919283926370a082319060240160206040518083038186803b1580156117d657600080fd5b505afa1580156117ea573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061180e9190615237565b6118189190615250565b90506000611829612b676001615146565b61183590612b67615268565b63ffffffff16611849612b67610457615268565b6118599063ffffffff1684615294565b61186586612b676150ca565b611870906002615268565b63ffffffff1661188091906151d3565b61188a9190615208565b61189690610457615250565b949350505050565b600d54600160201b900463ffffffff16612b67116118ce5760405162461bcd60e51b815260040161102b906152ab565b60006118d9336113dd565b905063ffffffff81166119245760405162461bcd60e51b81526020600482015260136024820152724e6f20636c61696d61626c65206f726465727360681b604482015260640161102b565b336000908152601860209081526040808320805482518185028101850190935280835291929091908301828280156119a757602002820191906000526020600020906000905b82829054906101000a900463ffffffff1663ffffffff168152602001906004019060208260030104928301926001038202915080841161196a5790505b50505050509050600080600090505b82518163ffffffff161015611a15576000838263ffffffff16815181106119df576119df61510c565b602002602001015190508563ffffffff168163ffffffff161415611a0257600192505b5080611a0d81615122565b9150506119b6565b50600181151514611a685760405162461bcd60e51b815260206004820152601a60248201527f4e6f206f72646572207769746820746869732065706f63684964000000000000604482015260640161102b565b6000611a72612f7d565b90508063ffffffff168563ffffffff1611611aa7576000611a928661370e565b90508015611aa557611aa386613baa565b505b505b5050505050565b600d54600090600160201b900463ffffffff16612b6711611ae15760405162461bcd60e51b815260040161102b906152ab565b82841115611b295760405162461bcd60e51b8152602060048201526015602482015274546f6f206c6f772072616e6b20746f20636c61696d60581b604482015260640161102b565b600083611b39600161010f6150ca565b611b499063ffffffff16876151d3565b611b539190615208565b9050600084611b65600161010f6150ca565b63ffffffff16611b76886001615250565b611b8091906151d3565b611b8a9190615208565b9050600082611b9a836001615250565b611ba49190615294565b611bae90866152cf565b611bb89084615250565b90506000611bc9600161010f6150ca565b600d5463ffffffff918216918491611bec9161010f91600160201b9004166152e3565b611bf9600161010f6150ca565b611c0391906150ca565b63ffffffff16611c1391906151d3565b611c1d9190615208565b600d54909150600090611c409061010f90600160201b900463ffffffff16615306565b90506000611c5261010f612b67615306565b9050611c5d8361521c565b9250815b612b6763ffffffff82161015611cd45760176000611c80836001615146565b63ffffffff16815260208101919091526040016000205460ff16611cac5783611ca881615329565b9450505b83611cc357611cbc816001615146565b9750611cd4565b611ccd8282615146565b9050611c61565b505050505050509392505050565b6000611ced60085490565b8210611d505760405162461bcd60e51b815260206004820152602c60248201527f455243373231456e756d657261626c653a20676c6f62616c20696e646578206f60448201526b7574206f6620626f756e647360a01b606482015260840161102b565b60088281548110611d6357611d6361510c565b90600052602060002001549050919050565b6001600160a01b038116600090815260186020526040812054610e5f906014615294565b600080601c60009054906101000a90046001600160a01b03166001600160a01b031663e7c830d46040518163ffffffff1660e01b815260040160206040518083038186803b158015611dea57600080fd5b505afa158015611dfe573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e229190615237565b9050600080611e32600a846150ca565b90505b8263ffffffff168163ffffffff1611611e7e5763ffffffff8082166000908152601b6020526040902054611e6a911683615146565b915080611e7681615122565b915050611e35565b50600d54611e9390829063ffffffff16615146565b9250505090565b611ea26135aa565b600d548190612b679060ff831690600160201b900463ffffffff16611ec5611d99565b611ecf9190615146565b611ed99190615146565b63ffffffff161115611efd5760405162461bcd60e51b815260040161102b9061516e565b33828060ff16611f0c83611d75565b1015611f2a5760405162461bcd60e51b815260040161102b9061519c565b601d5460405163534d7ee360e11b815260009182916001600160a01b039091169063a69afdc690611f6090600c90600401615340565b60606040518083038186803b158015611f7857600080fd5b505afa158015611f8c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611fb091906153e8565b925050915080600a611fc291906154fa565b8660ff16600e54611fd391906151d3565b611fdd91906151d3565b611fe783346151d3565b101561202a5760405162461bcd60e51b8152602060048201526012602482015271496e73756666696369656e742076616c756560701b604482015260640161102b565b6013546010546001600160a01b039091169063f6326fb39060649061204f90346151d3565b6120599190615208565b6040518263ffffffff1660e01b81526004016000604051808303818588803b15801561208457600080fd5b505af1158015612098573d6000803e3d6000fd5b5050505050611aa5866135f0565b6000818152600260205260408120546001600160a01b031680610e5f5760405162461bcd60e51b8152602060048201526018602482015277115490cdcc8c4e881a5b9d985b1a59081d1bdad95b88125160421b604482015260640161102b565b600b805461119d9061504a565b60006001600160a01b03821661217d5760405162461bcd60e51b815260206004820152602960248201527f4552433732313a2061646472657373207a65726f206973206e6f7420612076616044820152683634b21037bbb732b960b91b606482015260840161102b565b506001600160a01b031660009081526003602052604090205490565b6121a1613486565b6114b76000613d70565b601860205281600052604060002081815481106121c757600080fd5b9060005260206000209060089182820401919006600402915091509054906101000a900463ffffffff1681565b601d5460405163534d7ee360e11b815260009182916001600160a01b039091169063a69afdc6906122299086906004016149c1565b60606040518083038186803b15801561224157600080fd5b505afa158015612255573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061227991906153e8565b91959194509092505050565b61228d613486565b6011805460ff1916911515919091179055565b6122a8613486565b600e55565b6000806122b8612f7d565b905060005b6001600160a01b03841660009081526018602052604090205463ffffffff82161015611496576001600160a01b0384166000908152601860205260409020805463ffffffff80851692919084169081106123195761231961510c565b6000918252602090912060088204015460079091166004026101000a900463ffffffff161161234757612353565b61235083615122565b92505b8061235d81615122565b9150506122bd565b601a602052600090815260409020805461119d9061504a565b612386613486565b6040516370a0823160e01b81523060048201526001600160a01b0382169063a9059cbb90849083906370a082319060240160206040518083038186803b1580156123cf57600080fd5b505afa1580156123e3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124079190615237565b6040516001600160e01b031960e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381600087803b15801561244d57600080fd5b505af1158015612461573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110cc91906150ef565b606060018054610e749061504a565b600d54600160201b900463ffffffff16612b67116124c45760405162461bcd60e51b815260040161102b906152ab565b60006124cf336113dd565b905063ffffffff811661251a5760405162461bcd60e51b81526020600482015260136024820152724e6f20636c61696d61626c65206f726465727360681b604482015260640161102b565b3360009081526018602052604081205490612533612f7d565b905060005b8263ffffffff168163ffffffff16101561167957336000908152601860205260408120600161256784876150ca565b61257191906150ca565b63ffffffff16815481106125875761258761510c565b6000918252602090912060088204015460079091166004026101000a900463ffffffff9081169150831681116125d75760006125c28261370e565b905080156125d5576125d382613baa565b505b505b50806125e281615122565b915050612538565b6116bc338383613dca565b6125fd613486565b601180546001600160a01b03808a16620100000262010000600160b01b031990921691909117909155601c80549188166001600160a01b0319909216821790556040805163ce69f83360e01b8152905163ce69f83391600480820192600092909190829003018186803b15801561267357600080fd5b505afa158015612687573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526126af9190810190615506565b80516126c3916012916020909101906147d4565b50601380546001600160a01b038088166001600160a01b03199283161790925560148054878416908316179055601e805492861692909116919091179055805161271490600b906020840190614839565b5050601580546001600160a01b0319166001600160a01b03929092169190911790555050505050565b6127473383613e99565b6127635760405162461bcd60e51b815260040161102b90615595565b61167984848484613f17565b6011546201000090046001600160a01b0316331461279f5760405162461bcd60e51b815260040161102b90615085565b6127af828263ffffffff16613f4a565b60006127ba82611783565b601e549091506001600160a01b031663a9059cbb846127da600285615208565b6040516001600160e01b031960e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381600087803b15801561282057600080fd5b505af1158015612834573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061285891906150ef565b50601e546013546001600160a01b039182169163a9059cbb911661287d600285615208565b6040516001600160e01b031960e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381600087803b1580156128c357600080fd5b505af11580156128d7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906128fb91906150ef565b5063ffffffff8083166000908152601760205260409020805460ff19166001179055600d8054600160201b900490911690600461293783615122565b825463ffffffff9182166101009390930a928302919092021990911617905550601e546001600160a01b031660009081526019602052604081208054839290612981908490615250565b909155505060405163ffffffff8316906001600160a01b038516907f0f6798a560793a54c3bcfe86a93cde1e73087d944c0ea20544137d412139688590600090a3505050565b6011546000906201000090046001600160a01b031633146129fa5760405162461bcd60e51b815260040161102b90615085565b600d548290612b679060ff831690600160201b900463ffffffff16612a1d611d99565b612a279190615146565b612a319190615146565b63ffffffff161115612a555760405162461bcd60e51b815260040161102b9061516e565b63ffffffff8481166000908152601b602052604090205481871691612a7f9160ff87169116615146565b63ffffffff161115612a94576000915061177b565b63ffffffff8085166000908152601b60205260408120805460ff871693919291612ac091859116615146565b92506101000a81548163ffffffff021916908363ffffffff16021790555060019150509392505050565b612af26135aa565b600d548190612b679060ff831690600160201b900463ffffffff16612b15611d99565b612b1f9190615146565b612b299190615146565b63ffffffff161115612b4d5760405162461bcd60e51b815260040161102b9061516e565b33828060ff16612b5c83611d75565b1015612b7a5760405162461bcd60e51b815260040161102b9061519c565b60115460ff1615612bcd5760405162461bcd60e51b815260206004820152601b60248201527f77696c6c557365464c52436f7374206973206e6f7420666c6173650000000000604482015260640161102b565b6001600160a01b0385166000908152601a602052604081208054612bf09061504a565b80601f0160208091040260200160405190810160405280929190818152602001828054612c1c9061504a565b8015612c695780601f10612c3e57610100808354040283529160200191612c69565b820191906000526020600020905b815481529060010190602001808311612c4c57829003601f168201915b505050505090506000815111612cb55760405162461bcd60e51b81526020600482015260116024820152702ab739bab83837b93a32b2102a37b5b2b760791b604482015260640161102b565b601d5460405163534d7ee360e11b815260009182916001600160a01b039091169063a69afdc690612cea9086906004016149c1565b60606040518083038186803b158015612d0257600080fd5b505afa158015612d16573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612d3a91906153e8565b9193509091508890506000612d5083600a6154fa565b848a60ff16600e54612d6291906151d3565b612d6c9190615208565b612d7691906151d3565b6040516323b872dd60e01b8152336004820152306024820152604481018290529091506001600160a01b038316906323b872dd90606401602060405180830381600087803b158015612dc757600080fd5b505af1158015612ddb573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612dff91906150ef565b612e435760405162461bcd60e51b8152602060048201526015602482015274151bdad95b881d1c985b9cd9995c8819985a5b1959605a1b604482015260640161102b565b6013546010546001600160a01b038085169263a9059cbb92911690606490612e6b90866151d3565b612e759190615208565b6040516001600160e01b031960e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381600087803b158015612ebb57600080fd5b505af1158015612ecf573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612ef391906150ef565b50612efd896135f0565b50505050505050505050565b6060612f14826133b9565b6000612f2b60408051602081019091526000815290565b90506000815111612f4b5760405180602001604052806000815250612f76565b80612f55846140e3565b604051602001612f669291906155e2565b6040516020818303038152906040525b9392505050565b6000806000806000601c60009054906101000a90046001600160a01b03166001600160a01b03166393a790256040518163ffffffff1660e01b815260040160a06040518083038186803b158015612fd357600080fd5b505afa158015612fe7573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061300b9190615608565b9450509350935093506000600283856130249190615250565b61302e9190615208565b9050600082821161304957613044600187615294565b613054565b613054600287615294565b979650505050505050565b6012818154811061306f57600080fd5b6000918252602090912001546001600160a01b0316905081565b613091613486565b6001600160a01b0381166130f65760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b606482015260840161102b565b6130ff81613d70565b50565b61310a613486565b6001600160a01b0383166000908152601a602052604090206116799083836148ad565b60005b81518163ffffffff1610156116bc5760166000838363ffffffff168151811061315b5761315b61510c565b60200260200101516001600160a01b03166001600160a01b0316815260200190815260200160002054600014156131e75760166000838363ffffffff16815181106131a8576131a861510c565b60200260200101516001600160a01b03166001600160a01b0316815260200190815260200160002060008154809291906131e19061521c565b91905055505b806131f181615122565b915050613130565b613201613486565b601180549115156101000261ff0019909216919091179055565b600d54600190612b67908290600160201b900463ffffffff1661323c611d99565b6132469190615146565b6132509190615146565b63ffffffff1611156132745760405162461bcd60e51b815260040161102b9061516e565b3360018061328183611d75565b101561329f5760405162461bcd60e51b815260040161102b9061519c565b60115460ff6101009091041615156001146132f15760405162461bcd60e51b8152602060048201526012602482015271151d5c9b8813d999881dda1a5d195b1a5cdd60721b604482015260640161102b565b3360009081526016602052604090205461333f5760405162461bcd60e51b815260206004820152600f60248201526e139bdd081dda1a5d195b1a5cdd1959608a1b604482015260640161102b565b33600090815260166020526040812080549161335a83615329565b91905055506110cc60016135f0565b60006001600160e01b031982166380ac58cd60e01b148061339a57506001600160e01b03198216635b5e139f60e01b145b80610e5f57506301ffc9a760e01b6001600160e01b0319831614610e5f565b6000818152600260205260409020546001600160a01b03166130ff5760405162461bcd60e51b8152602060048201526018602482015277115490cdcc8c4e881a5b9d985b1a59081d1bdad95b88125160421b604482015260640161102b565b600081815260046020526040902080546001600160a01b0319166001600160a01b038416908117909155819061344d826120a6565b6001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b600a546001600160a01b036101009091041633146114b75760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161102b565b6134f03382613e99565b61350c5760405162461bcd60e51b815260040161102b90615595565b6110cc838383614178565b61351f6135aa565b600a805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a2586135543390565b6040516001600160a01b03909116815260200160405180910390a1565b6135796142e9565b600a805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa33613554565b600a5460ff16156114b75760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161102b565b601c54604080516393a7902560e01b815290516000926001600160a01b0316916393a790259160048083019260a0929190829003018186803b15801561363557600080fd5b505afa158015613649573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061366d9190615608565b50505050905060005b8260ff168160ff1610156110cc57336000908152601860209081526040822080546001810182559083529082206008820401805460079092166004026101000a63ffffffff8181021990931686841691909102179055600d80549092916136dd9116615122565b91906101000a81548163ffffffff021916908363ffffffff160217905550808061370690615648565b915050613676565b3360009081526018602052604081205481805b828110156137a15733600090815260186020526040902080548290811061374a5761374a61510c565b90600052602060002090600891828204019190066004029054906101000a900463ffffffff1663ffffffff168563ffffffff16141561378f5761378c82615122565b91505b806137998161521c565b915050613721565b50600067112210f68103952b60126000815481106137c1576137c161510c565b600091825260209091200154604051633352da4560e21b815263ffffffff881660048201526001600160a01b039091169063cd4b69149060240160206040518083038186803b15801561381357600080fd5b505afa158015613827573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061384b9190615237565b61385591906152cf565b6040805160208101929092526bffffffffffffffffffffffff193360601b169082015260540160408051601f198184030181529190528051602090910120905060006138a26014846152e3565b6138ae9061010f6150ca565b6138be9063ffffffff16836152cf565b905060006138cf600161010f6150ca565b600d5463ffffffff9182169184916138f29161010f91600160201b9004166152e3565b6138ff600161010f6150ca565b61390991906150ca565b63ffffffff1661391991906151d3565b6139239190615208565b600d549091506000906139469061010f90600160201b900463ffffffff16615306565b9050600061395861010f612b67615306565b90506139638361521c565b925060008161397484612b67615146565b61397e91906150ca565b9050805b8363ffffffff168163ffffffff1610613b995760006139a2826001615146565b63ffffffff811660009081526017602052604090205490915060ff166139ce576139cb86615329565b95505b6001861015613b87576139e7338263ffffffff16613f4a565b60006139f282611783565b601e5460405163a9059cbb60e01b8152336004820152602481018390529192506001600160a01b03169063a9059cbb90604401602060405180830381600087803b158015613a3f57600080fd5b505af1158015613a53573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613a7791906150ef565b5063ffffffff8083166000908152601760205260409020805460ff19166001179055600d8054600160201b9004909116906004613ab383615122565b825463ffffffff9182166101009390930a928302919092021990911617905550601e546001600160a01b031660009081526019602052604081208054839290613afd908490615250565b9091555050600d805463ffffffff16906000613b1883615668565b91906101000a81548163ffffffff021916908363ffffffff160217905550508163ffffffff16336001600160a01b03167f0f6798a560793a54c3bcfe86a93cde1e73087d944c0ea20544137d412139688560405160405180910390a35060019c9b505050505050505050505050565b50613b9283826150ca565b9050613982565b5060009a9950505050505050505050565b33600090815260186020526040812054815b81811015613d66573360009081526018602052604090206001613bdf8385615294565b613be99190615294565b81548110613bf957613bf961510c565b90600052602060002090600891828204019190066004029054906101000a900463ffffffff1663ffffffff168463ffffffff161415613d5457336000908152601860205260409020613c4c600184615294565b81548110613c5c57613c5c61510c565b600091825260208083206008830401543384526018909152604090922060079091166004026101000a90910463ffffffff16906001613c9b8486615294565b613ca59190615294565b81548110613cb557613cb561510c565b90600052602060002090600891828204019190066004026101000a81548163ffffffff021916908363ffffffff16021790555060186000336001600160a01b03166001600160a01b03168152602001908152602001600020805480613d1c57613d1c615688565b600082815260209020600860001990920191820401805463ffffffff600460078516026101000a021916905590555060019392505050565b80613d5e8161521c565b915050613bbc565b5060009392505050565b600a80546001600160a01b03838116610100818102610100600160a81b031985161790945560405193909204169182907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b816001600160a01b0316836001600160a01b03161415613e2c5760405162461bcd60e51b815260206004820152601960248201527f4552433732313a20617070726f766520746f2063616c6c657200000000000000604482015260640161102b565b6001600160a01b03838116600081815260056020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b600080613ea5836120a6565b9050806001600160a01b0316846001600160a01b03161480613eec57506001600160a01b0380821660009081526005602090815260408083209388168352929052205460ff165b806118965750836001600160a01b0316613f0584610ef7565b6001600160a01b031614949350505050565b613f22848484614178565b613f2e84848484614332565b6116795760405162461bcd60e51b815260040161102b9061569e565b6001600160a01b038216613fa05760405162461bcd60e51b815260206004820181905260248201527f4552433732313a206d696e7420746f20746865207a65726f2061646472657373604482015260640161102b565b6000818152600260205260409020546001600160a01b0316156140055760405162461bcd60e51b815260206004820152601c60248201527f4552433732313a20746f6b656e20616c7265616479206d696e74656400000000604482015260640161102b565b61401360008383600161443f565b6000818152600260205260409020546001600160a01b0316156140785760405162461bcd60e51b815260206004820152601c60248201527f4552433732313a20746f6b656e20616c7265616479206d696e74656400000000604482015260640161102b565b6001600160a01b038216600081815260036020908152604080832080546001019055848352600290915280822080546001600160a01b0319168417905551839291907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b606060006140f08361456c565b600101905060008167ffffffffffffffff81111561411057614110614bcd565b6040519080825280601f01601f19166020018201604052801561413a576020820181803683370190505b5090508181016020015b600019016f181899199a1a9b1b9c1cb0b131b232b360811b600a86061a8153600a85049450846141735761177b565b614144565b826001600160a01b031661418b826120a6565b6001600160a01b0316146141b15760405162461bcd60e51b815260040161102b906156f0565b6001600160a01b0382166142135760405162461bcd60e51b8152602060048201526024808201527f4552433732313a207472616e7366657220746f20746865207a65726f206164646044820152637265737360e01b606482015260840161102b565b614220838383600161443f565b826001600160a01b0316614233826120a6565b6001600160a01b0316146142595760405162461bcd60e51b815260040161102b906156f0565b600081815260046020908152604080832080546001600160a01b03199081169091556001600160a01b0387811680865260038552838620805460001901905590871680865283862080546001019055868652600290945282852080549092168417909155905184937fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef91a4505050565b600a5460ff166114b75760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b604482015260640161102b565b60006001600160a01b0384163b1561443457604051630a85bd0160e11b81526001600160a01b0385169063150b7a0290614376903390899088908890600401615735565b602060405180830381600087803b15801561439057600080fd5b505af19250505080156143c0575060408051601f3d908101601f191682019092526143bd91810190615772565b60015b61441a573d8080156143ee576040519150601f19603f3d011682016040523d82523d6000602084013e6143f3565b606091505b5080516144125760405162461bcd60e51b815260040161102b9061569e565b805181602001fd5b6001600160e01b031916630a85bd0160e11b149050611896565b506001949350505050565b60018111156144ae5760405162461bcd60e51b815260206004820152603560248201527f455243373231456e756d657261626c653a20636f6e7365637574697665207472604482015274185b9cd9995c9cc81b9bdd081cdd5c1c1bdc9d1959605a1b606482015260840161102b565b816001600160a01b03851661450a5761450581600880546000838152600960205260408120829055600182018355919091527ff3f7a9fe364faab93b216da50a3214154f22a0a2b415b23a84c8169e8b636ee30155565b61452d565b836001600160a01b0316856001600160a01b03161461452d5761452d8582614644565b6001600160a01b03841661454957614544816146e1565b611aa7565b846001600160a01b0316846001600160a01b031614611aa757611aa78482614790565b60008072184f03e93ff9f4daa797ed6e38ed64bf6a1f0160401b83106145ab5772184f03e93ff9f4daa797ed6e38ed64bf6a1f0160401b830492506040015b6d04ee2d6d415b85acef810000000083106145d7576d04ee2d6d415b85acef8100000000830492506020015b662386f26fc1000083106145f557662386f26fc10000830492506010015b6305f5e100831061460d576305f5e100830492506008015b612710831061462157612710830492506004015b60648310614633576064830492506002015b600a8310610e5f5760010192915050565b6000600161465184612113565b61465b9190615294565b6000838152600760205260409020549091508082146146ae576001600160a01b03841660009081526006602090815260408083208584528252808320548484528184208190558352600790915290208190555b5060009182526007602090815260408084208490556001600160a01b039094168352600681528383209183525290812055565b6008546000906146f390600190615294565b6000838152600960205260408120546008805493945090928490811061471b5761471b61510c565b90600052602060002001549050806008838154811061473c5761473c61510c565b600091825260208083209091019290925582815260099091526040808220849055858252812055600880548061477457614774615688565b6001900381819060005260206000200160009055905550505050565b600061479b83612113565b6001600160a01b039093166000908152600660209081526040808320868452825280832085905593825260079052919091209190915550565b828054828255906000526020600020908101928215614829579160200282015b8281111561482957825182546001600160a01b0319166001600160a01b039091161782556020909201916001909101906147f4565b50614835929150614921565b5090565b8280546148459061504a565b90600052602060002090601f0160209004810192826148675760008555614829565b82601f1061488057805160ff1916838001178555614829565b82800160010185558215614829579182015b82811115614829578251825591602001919060010190614892565b8280546148b99061504a565b90600052602060002090601f0160209004810192826148db5760008555614829565b82601f106148f45782800160ff19823516178555614829565b82800160010185558215614829579182015b82811115614829578235825591602001919060010190614906565b5b808211156148355760008155600101614922565b6001600160e01b0319811681146130ff57600080fd5b60006020828403121561495e57600080fd5b8135612f7681614936565b60005b8381101561498457818101518382015260200161496c565b838111156116795750506000910152565b600081518084526149ad816020860160208601614969565b601f01601f19169290920160200192915050565b602081526000612f766020830184614995565b6000602082840312156149e657600080fd5b5035919050565b6001600160a01b03811681146130ff57600080fd5b600060208284031215614a1457600080fd5b8135612f76816149ed565b6020808252825182820181905260009190848201906040850190845b81811015614a5d57835163ffffffff1683529284019291840191600101614a3b565b50909695505050505050565b60008060408385031215614a7c57600080fd5b8235614a87816149ed565b946020939093013593505050565b803563ffffffff81168114614aa957600080fd5b919050565b803560ff81168114614aa957600080fd5b60008060408385031215614ad257600080fd5b614adb83614a95565b9150614ae960208401614aae565b90509250929050565b600080600060608486031215614b0757600080fd5b8335614b12816149ed565b92506020840135614b22816149ed565b929592945050506040919091013590565b600060208284031215614b4557600080fd5b612f7682614aae565b6020808252825182820181905260009190848201906040850190845b81811015614a5d57835183529284019291840191600101614b6a565b600060208284031215614b9857600080fd5b612f7682614a95565b600080600060608486031215614bb657600080fd5b505081359360208301359350604090920135919050565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff81118282101715614c0c57614c0c614bcd565b604052919050565b600067ffffffffffffffff831115614c2e57614c2e614bcd565b614c41601f8401601f1916602001614be3565b9050828152838383011115614c5557600080fd5b828260208301376000602084830101529392505050565b600082601f830112614c7d57600080fd5b612f7683833560208501614c14565b600060208284031215614c9e57600080fd5b813567ffffffffffffffff811115614cb557600080fd5b61189684828501614c6c565b80151581146130ff57600080fd5b600060208284031215614ce157600080fd5b8135612f7681614cc1565b60008060408385031215614cff57600080fd5b8235614d0a816149ed565b91506020830135614d1a816149ed565b809150509250929050565b60008060408385031215614d3857600080fd5b8235614d43816149ed565b91506020830135614d1a81614cc1565b600080600080600080600060e0888a031215614d6e57600080fd5b8735614d79816149ed565b96506020880135614d89816149ed565b95506040880135614d99816149ed565b94506060880135614da9816149ed565b93506080880135614db9816149ed565b925060a0880135614dc9816149ed565b915060c088013567ffffffffffffffff811115614de557600080fd5b614df18a828b01614c6c565b91505092959891949750929550565b60008060008060808587031215614e1657600080fd5b8435614e21816149ed565b93506020850135614e31816149ed565b925060408501359150606085013567ffffffffffffffff811115614e5457600080fd5b8501601f81018713614e6557600080fd5b614e7487823560208401614c14565b91505092959194509250565b60008060408385031215614e9357600080fd5b8235614e9e816149ed565b9150614ae960208401614a95565b600080600060608486031215614ec157600080fd5b614eca84614a95565b9250614ed860208501614a95565b9150614ee660408501614aae565b90509250925092565b60008060408385031215614f0257600080fd5b8235614adb816149ed565b600080600060408486031215614f2257600080fd5b8335614f2d816149ed565b9250602084013567ffffffffffffffff80821115614f4a57600080fd5b818601915086601f830112614f5e57600080fd5b813581811115614f6d57600080fd5b876020828501011115614f7f57600080fd5b6020830194508093505050509250925092565b600067ffffffffffffffff821115614fac57614fac614bcd565b5060051b60200190565b60006020808385031215614fc957600080fd5b823567ffffffffffffffff811115614fe057600080fd5b8301601f81018513614ff157600080fd5b8035615004614fff82614f92565b614be3565b81815260059190911b8201830190838101908783111561502357600080fd5b928401925b8284101561305457833561503b816149ed565b82529284019290840190615028565b600181811c9082168061505e57607f821691505b6020821081141561507f57634e487b7160e01b600052602260045260246000fd5b50919050565b60208082526015908201527427b7363c9027232a2932bbb0b93226b0b730b3b2b960591b604082015260600190565b634e487b7160e01b600052601160045260246000fd5b600063ffffffff838116908316818110156150e7576150e76150b4565b039392505050565b60006020828403121561510157600080fd5b8151612f7681614cc1565b634e487b7160e01b600052603260045260246000fd5b600063ffffffff8083168181141561513c5761513c6150b4565b6001019392505050565b600063ffffffff808316818516808303821115615165576151656150b4565b01949350505050565b602080825260149082015273105b1b081391951cc8185c99481bdc99195c995960621b604082015260600190565b6020808252601c908201527f596f75722063616e2774206f72646572207375636820636f756e747300000000604082015260600190565b60008160001904831182151516156151ed576151ed6150b4565b500290565b634e487b7160e01b600052601260045260246000fd5b600082615217576152176151f2565b500490565b6000600019821415615230576152306150b4565b5060010190565b60006020828403121561524957600080fd5b5051919050565b60008219821115615263576152636150b4565b500190565b600063ffffffff8083168185168183048111821515161561528b5761528b6150b4565b02949350505050565b6000828210156152a6576152a66150b4565b500390565b6020808252600a9082015269105b1b081b5a5b9d195960b21b604082015260600190565b6000826152de576152de6151f2565b500690565b600063ffffffff808416806152fa576152fa6151f2565b92169190910692915050565b600063ffffffff8084168061531d5761531d6151f2565b92169190910492915050565b600081615338576153386150b4565b506000190190565b600060208083526000845481600182811c91508083168061536257607f831692505b85831081141561538057634e487b7160e01b85526022600452602485fd5b87860183815260200181801561539d57600181146153ae576153d9565b60ff198616825287820196506153d9565b60008b81526020902060005b868110156153d3578154848201529085019089016153ba565b83019750505b50949998505050505050505050565b6000806000606084860312156153fd57600080fd5b8351925060208401519150604084015190509250925092565b600181815b80851115615451578160001904821115615437576154376150b4565b8085161561544457918102915b93841c939080029061541b565b509250929050565b60008261546857506001610e5f565b8161547557506000610e5f565b816001811461548b5760028114615495576154b1565b6001915050610e5f565b60ff8411156154a6576154a66150b4565b50506001821b610e5f565b5060208310610133831016604e8410600b84101617156154d4575081810a610e5f565b6154de8383615416565b80600019048211156154f2576154f26150b4565b029392505050565b6000612f768383615459565b6000602080838503121561551957600080fd5b825167ffffffffffffffff81111561553057600080fd5b8301601f8101851361554157600080fd5b805161554f614fff82614f92565b81815260059190911b8201830190838101908783111561556e57600080fd5b928401925b82841015613054578351615586816149ed565b82529284019290840190615573565b6020808252602d908201527f4552433732313a2063616c6c6572206973206e6f7420746f6b656e206f776e6560408201526c1c881bdc88185c1c1c9bdd9959609a1b606082015260800190565b600083516155f4818460208801614969565b835190830190615165818360208801614969565b600080600080600060a0868803121561562057600080fd5b5050835160208501516040860151606087015160809097015192989197509594509092509050565b600060ff821660ff81141561565f5761565f6150b4565b60010192915050565b600063ffffffff82168061567e5761567e6150b4565b6000190192915050565b634e487b7160e01b600052603160045260246000fd5b60208082526032908201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560408201527131b2b4bb32b91034b6b83632b6b2b73a32b960711b606082015260800190565b60208082526025908201527f4552433732313a207472616e736665722066726f6d20696e636f72726563742060408201526437bbb732b960d91b606082015260800190565b6001600160a01b038581168252841660208201526040810183905260806060820181905260009061576890830184614995565b9695505050505050565b60006020828403121561578457600080fd5b8151612f768161493656fea2646970667358221220467ae12730da6f2b8eff198483b649e1d918941fb3abe7a3c074ccb580217aa264736f6c6343000809003368747470733a2f2f617263686574797065732e6e7963332e63646e2e6469676974616c6f6365616e7370616365732e636f6d2f6d657461646174612f";

type Token1ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: Token1ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Token1__factory extends ContractFactory {
  constructor(...args: Token1ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _name: PromiseOrValue<string>,
    _symbol: PromiseOrValue<string>,
    _nativeTokenSymbol: PromiseOrValue<string>,
    _ftsoManager: PromiseOrValue<string>,
    _visToken: PromiseOrValue<string>,
    _wNat: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Token1> {
    return super.deploy(
      _name,
      _symbol,
      _nativeTokenSymbol,
      _ftsoManager,
      _visToken,
      _wNat,
      overrides || {}
    ) as Promise<Token1>;
  }
  override getDeployTransaction(
    _name: PromiseOrValue<string>,
    _symbol: PromiseOrValue<string>,
    _nativeTokenSymbol: PromiseOrValue<string>,
    _ftsoManager: PromiseOrValue<string>,
    _visToken: PromiseOrValue<string>,
    _wNat: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _name,
      _symbol,
      _nativeTokenSymbol,
      _ftsoManager,
      _visToken,
      _wNat,
      overrides || {}
    );
  }
  override attach(address: string): Token1 {
    return super.attach(address) as Token1;
  }
  override connect(signer: Signer): Token1__factory {
    return super.connect(signer) as Token1__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Token1Interface {
    return new utils.Interface(_abi) as Token1Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Token1 {
    return new Contract(address, _abi, signerOrProvider) as Token1;
  }
}
